import AnalyticsBase from './AnalyticsBase';

class TravelDetailsEvent extends AnalyticsBase {
  step?: string;

  travel_duration?: number;

  hotel?: string;

  amount_rooms?: number;

  hotel_meals?: string;
}

export default TravelDetailsEvent;
